import {Category} from "@material-ui/icons";

//지역 리스트
export const regionList = [
  "서울",
  "부산",
  "대구",
  "인천",
  "광주",
  "대전",
  "울산",
  "세종",
  "경기",
  "강원",
  "충북",
  "충남",
  "전북",
  "전남",
  "경북",
  "경남",
  "제주",
];

//프로젝트 작성 분류

interface projectCategoryType {
  id: number;
  name: string;
  category: string[];
}

export const projectCategory: projectCategoryType[] = [
  {
    id: 1,
    name: "안전경영과 근로자 참여",
    category: [
      "공장장",
      "부장/과장",
      "조장/반장",
      "현장작업자",
      "정비보수작업자",
      "도급업체 작업자",
      "안전관리자",
    ],
  },
  {
    id: 2,
    name: "안전운전계획",
    category: [
      "안전운전 지침과 절차",
      "설비의 점검·검사·보수 계획, 유지계획 및 지침",
      "안전작업허가 및 절차",
      "도급업체 안전관리",
      "공정·운전에 대한 교육·훈련",
      "가동전 점검지침",
      "변경요소관리",
      "자체감사",
      "공정사고조사",
    ],
  },
];
